import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { QuotesAcceptedQuotesComponent } from './quotes.accepted-quotes.component';
import { QuotesService }                 from './quotes.service';
import { SharedModule }                  from '../shared/shared.module';
import { TableModule }                   from '../table/table.module';

@NgModule({
  declarations: [
    QuotesAcceptedQuotesComponent
  ],
  entryComponents: [
    QuotesAcceptedQuotesComponent
  ],
  exports: [
    QuotesAcceptedQuotesComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    QuotesService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class QuotesModule {}
